import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'pb0100',
    ecrans: ['00-2']
});